export const taskCardContent = {
  draggableId: 'tasks',
  heading: 'Aufgaben',
  jira: 'Jira',
  columnLabels: {
    titel: 'Titel',
    taskStatus: 'Taskstatus',
    bearbeiter: 'Bearbeiter',
    labels: 'Labels',
  },
  jiraNotAvailable:
    'Die Jira-Anbindung ist aktuell nicht verfügbar. Bitte die Fehler-Details mit dem Button rechts in die Zwischenablage kopieren und an VAMOS schicken.',
} as const;
